import { takeLatest, put, call } from 'redux-saga/effects';
import { getDashboardPluviometro } from '../service';
import {
    TOTAIS_DASHBOARD_PLUVIOMETRO,
    TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING,
    TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS,
    TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE
} from '../actionTypes';

// Função auxiliar para formatar data (YYYY-MM-DD -> DD/MM)
function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
}

// Função auxiliar para processar os dados da API
function processChartData(data) {
    if (!data || data.length === 0) {
        return {
            totais: {
                precipitacaoTotal: 0,
                temperaturaMedia: 0,
                umidadeMedia: 0,
                diasChuva: 0,
                pressaoMedia: 0
            },
            graficos: {
                precipitacaoDiaria: null,
                umidadeRelativa: null,
                pressaoAtmosferica: null,
                variacaoTemperatura: null
            }
        };
    }

    // Calcular totalizadores
    let somaPrecipitacao = 0;
    let somaTemperatura = 0;
    let somaUmidade = 0;
    let somaPressao = 0;
    let diasChuva = 0;

    data.forEach(item => {
        somaPrecipitacao += parseFloat(item.precipitation || 0);
        somaTemperatura += parseFloat(item.temperature || 0);
        somaUmidade += parseFloat(item.humidity || 0);
        somaPressao += parseFloat(item.atmosphericPressure || 0);
        if (parseFloat(item.precipitation || 0) > 0) {
            diasChuva++;
        }
    });

    const count = data.length;

    const totais = {
        precipitacaoTotal: somaPrecipitacao,
        temperaturaMedia: count > 0 ? somaTemperatura / count : 0,
        umidadeMedia: count > 0 ? somaUmidade / count : 0,
        diasChuva: diasChuva,
        pressaoMedia: count > 0 ? somaPressao / count : 0
    };

    // Preparar dados para os gráficos (formato Google Charts)
    const precipitacaoDiaria = [['Período', 'Precipitação']];
    const umidadeRelativa = [['Período', 'Umidade']];
    const pressaoAtmosferica = [['Período', 'Pressão']];
    const variacaoTemperatura = [['Período', 'Temperatura']];

    data.forEach(item => {
        const dataFormatada = formatDate(item.date);
        precipitacaoDiaria.push([dataFormatada, parseFloat(item.precipitation || 0)]);
        umidadeRelativa.push([dataFormatada, parseFloat(item.humidity || 0)]);
        pressaoAtmosferica.push([dataFormatada, parseFloat(item.atmosphericPressure || 0)]);
        variacaoTemperatura.push([dataFormatada, parseFloat(item.temperature || 0)]);
    });

    const graficos = {
        precipitacaoDiaria,
        umidadeRelativa,
        pressaoAtmosferica,
        variacaoTemperatura
    };

    return { totais, graficos };
}

function* sagaTotaisPluviometro(action) {
    yield put({ type: TOTAIS_DASHBOARD_PLUVIOMETRO_PENDING });

    try {
        const { dataInicial, dataFinal, estacaoMeteorologicaId } = action;

        const response = yield call(
            getDashboardPluviometro,
            dataInicial,
            dataFinal,
            estacaoMeteorologicaId
        );

        // Processar dados da API
        const { totais, graficos } = processChartData(response.data);

        yield put({
            type: TOTAIS_DASHBOARD_PLUVIOMETRO_SUCCESS,
            totais,
            graficos
        });
    } catch (error) {
        yield put({ type: TOTAIS_DASHBOARD_PLUVIOMETRO_FAILURE });
    }
}

export default function* watchTotaisPluviometro() {
    yield takeLatest(TOTAIS_DASHBOARD_PLUVIOMETRO, sagaTotaisPluviometro);
}
